import { GET_CURRENT_USER_DOCUMENT } from "../graphql";

export function preCacheCurrentUser(client) {
    // Load the JSON of the currentUser query from the DOM.
    const jsonElement = document.getElementById("current-user");
    const userData = jsonElement && JSON.parse(jsonElement.innerHTML);

    // Pre-cache the results of the currentUser query.
    client.writeQuery({
        query: GET_CURRENT_USER_DOCUMENT,
        data: userData
    });
}

export function clearCurrentUserCache(client) {
    // Pre-cache the results of the currentUser query.
    client.writeQuery({
        query: GET_CURRENT_USER_DOCUMENT,
        data: { currentUser: null }
    });
}
